<template>
  <div class="container">
    <div class="content">
      <div class="left">
        <div class="menu-container">
          <div class="menu-title">业务领域</div>
          <ul>
            <li v-for="(item,index) in menuList" 
                :key="index" 
                @click="getNewsList(index,item.type)"
                :class="{ selected: selected === index }"
            >
              {{item.name}}
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <!-- <articleDetails ></articleDetails> -->
        <div class="article-container">
          <div class="article-position">
            <!-- 当前位置:XXX/XXXX/XXX -->
            <div class="default-padding" v-show="!$route.meta.noTitle">
              当前位置：<span style="cursor: pointer" @click="goback">{{
                parentTitle
              }}</span>
              / {{ title }}
            </div>
          </div>
          <div class="article-content" >
            <indexList
              :showPage="showPage"
              :showTime="showTime"
              :toSpan="'businessArea'"
              :type="showType"
            ></indexList>
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftMenu from "../components/leftMenu";
// import articleDetails from "../components/articleDetails";
import indexList from "../components/indexList";
export default {
  components: {
    leftMenu,
    // articleDetails,
    indexList,
  },
  name: "plan",
  data() {
    return {
      id: "",
      id2: "",
      id3: "",
      // content: [],
      routerTitle: {},
      newsDetails: {},
      newsDetails2: {},
      selected:0,
      showPage: "showPage",
      showTime: "showTime",
      showType:null,
      firstType:null,
      menuList: [
        {
          type: '11',
          name: "矿产资源综合开发利用",
        },
        {
          type: '12',
          name: "大宗固废综合利用",
        },
        {
          type: '13',
          name: "园区循环化发展",
        },
        {
          type: '14',
          name: "资源再生利用",
        },
        {
          type: '15',
          name: "再制造",
        },
        {
          type: '16',
          name: "垃圾资源化",
        },
        {
          type: '17',
          name: "农林废物综合利用",
        },
        {
          type: '18',
          name: "水资源利用",
        },
        {
          type: '19',
          name: "绿色消费",
        },
      ],
    };
  },
  computed: {
    // title() {
    //   return this.$route && this.$route.meta && this.$route.meta.title;
    // },
    title() {
      return this.$route && this.$route.meta && this.$route.meta.title;
    },
    parentTitle() {
      return this.$route && this.$route.meta && this.$route.meta.parent;
    },
  },
  methods: {
    goback() {
      if (this.title == "业务领域") {
        this.$router.push("/index");
      }
    },
    async getList(index,type){
      console.log('执行了getList',index,type)
      this.$router.push({ 
        url:'/businessArea',
        query: {
          index:index,
          type:type,
        } 
      });
      this.selected = index;
      this.showType=type
      // let params = {
      //   type: type,
      // };
      // try {
      //   const res = await this.API.plat.pageList(params);
      //   if (res.success == true) {
      //     this.showType=type
      //     // this.id = res.entity.content[0].id;
      //     // this.getDetails(this.id);
      //   }
      // } catch (error) {
      //   // console.log(error);
      // }
    },
    async getNewsList(index,type){
      console.log('执行了getNewsList',index,type)
      this.$router.push({ 
        url:'/businessArea',
        query: {
          index:index,
          type:type,
        } 
      });
      this.selected = index;
      this.showType=type
    },
    async getDetails(id){
      let params = {
        id: id,
      };
      try {
        const res = await this.API.plat.newsDetails(params);
        if (res.success == true) {
          this.newsDetails = res.entity;
        }
      } catch (error) {
        // console.log(error);
      }
    },
    // 菜单列表
    async getMenuList() {
      try {
        const res = await this.API.plat.menuList();
        if (res.success == true) {
          res.entity.forEach((ele) => {
            if(ele.name=='业务领域'){
              this.menuList=ele.menuResp
              localStorage.setItem("menuList", JSON.stringify(res.entity));
              this.firstType=ele.menuResp[0].type
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    }, 
  },
  created() {
    // this.getMenuList().then(async() => {
    //   if(this.$route.query.type){
    //   this.getList(Number(this.$route.query.index),Number(this.$route.query.type))
    //   }else{
    //     this.getList(0,this.firstType)
    //   }
    // });
    if(JSON.parse(localStorage.getItem('menuList'))!=null){
      this.menuList=JSON.parse(localStorage.getItem('menuList'))
      this.menuList.forEach((ele) => {
        if(ele.name=='业务领域'){
          this.menuList=ele.menuResp
          this.firstType=ele.menuResp[0].type
        }
      });
    }else{
      this.getMenuList().then(async() => {
        if(this.$route.query.type){
          this.getList(Number(this.$route.query.index),Number(this.$route.query.type))
        }else{
          this.getList(0,this.firstType)
        }
      });
    }
    
    if(this.$route.query.type){
      this.getList(Number(this.$route.query.index),Number(this.$route.query.type))
    }else{
      this.getList(0,this.firstType)
    }
  },
  watch: {
    '$route.query': function (val) {
      //深度监听，可监听到对象、数组的变化
      console.log('id',val)
      if(val){
        this.showType=val.type
        console.log('showType',this.showType)
        this.getList(val.index,val.type)
        if(JSON.stringify(val) == "{}"||val.type==undefined){
          this.getList(0,this.firstType)
        } 
      }
    },
    deep: true, //true 深度监听
    immediate:true,
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  justify-content: center;
  min-height: 950px;
  .content {
    // width: 70%; //固定宽度改为百分比
    width: 1200px;
    // border: 1px solid #ccc;
    border-radius: 1px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    z-index: 99;
    display: flex;
    .left {
      width: 20%;
      height: 100%;
      // border: 1px solid #ccc;
      border-radius: 1px;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
      background: #fff;
      margin-right: 20px;
      .menu-container {
        width: 90%;
        // border: 1px solid #ccc;
        margin: 16px auto;
        .menu-title {
          height: 70px;
          width: 100%;
          background-image: url("../assets/css/img/menu-1.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          color: #fff;
          font-size: 22px;
          padding-left: 14%;
          line-height: 70px;
        }
        ul {
          width: 100%;
          li {
            height: 60px;
            line-height: 60px;
            background: #f5f5f5;
            color: #333333;
            font-size: 14px;
            text-align: center;
            margin-top: 2px;
            cursor: pointer;
            border-radius: 2px;
          }
          li:hover {
            color: #1954ad;
            cursor: pointer;
          }
        }
      }
    }
    .right {
      width: 80%;
      height: 100%;
      // border: 1px solid #ccc;
      border-radius: 1px;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
      background: #fff;
      .article-container {
        width: 100%;
        // border: 1px solid #ccc;
        text-align: center;
        .article-position {
          height: 58px;
          line-height: 58px;
          border-bottom: 2px solid #eaeaea;
          padding-left: 6%;
          text-align: left;
        }
        .article-content {
          width: 90%;
          margin: 0 auto;
          text-align: left;
          .article-name {
            font-size: 18px;
            margin-top: 40px;
          }
          .article-title {
            // font-size: 30px;
            margin: 40px auto;
          }
          .article-time {
            font-size: 14px;
            color: #999;
          }
          p {
            font-size: 16px;
            color: #333;
            margin: 40px 0;
            line-height: 36px;
            text-align: left;
          }
        }
      }
    }
  }
}
.selected{
  color: #fff !important;
  background: #0e90f2 !important;
}
</style>